import { ApplicationsAction, ApplicationsActionNames } from "./actions";

export interface IApplicationsState {
  loadedWidgets: string[];
  loadedFullscreenWidgets: string[];
  widgetsEnabled: boolean;
}

export const initialState = {
  loadedWidgets: [],
  loadedFullscreenWidgets: [],
  widgetsEnabled: true,
};

const applicationsReducer = (
  state: IApplicationsState = initialState,
  action: ApplicationsAction
): IApplicationsState => {
  switch (action.type) {
    case ApplicationsActionNames.LOAD_WIDGET:
      if (state.loadedWidgets.indexOf(action.payload.id) < 0) {
        return {
          ...state,
          loadedWidgets: [...state.loadedWidgets, action.payload.id],
        };
      }
      return state;

    case ApplicationsActionNames.LOAD_FULLSCREEN_WIDGET:
      if (!state.loadedFullscreenWidgets.includes(action.payload.id)) {
        return {
          ...state,
          loadedFullscreenWidgets: [...state.loadedFullscreenWidgets, action.payload.id],
        };
      }
      return state;

    case ApplicationsActionNames.WIDGETS_DISABLE: {
      return {
        ...state,
        widgetsEnabled: false,
      };
    }
    default:
      return state;
  }
};

export default applicationsReducer;
